/**
 * El backend envia importes en centavos enteros. Aqui, y solo aqui, se
 * convierten a texto para mostrar.
 */
export function formatMoney(cents: number | null | undefined, currency = 'MXN'): string {
  if (cents === null || cents === undefined) return '-'

  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(cents / 100)
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium' }).format(new Date(iso))
}

/**
 * A calendar day the server sends as `yyyy-MM-dd`, shown as dd/MM/yyyy. It is read
 * as written: going through `Date` would move it a day back west of UTC.
 */
export function formatDay(day: string | null | undefined): string {
  const parts = day ? /^(\d{4})-(\d{2})-(\d{2})/.exec(day) : null
  return parts ? `${parts[3]}/${parts[2]}/${parts[1]}` : '—'
}

/** Today in the browser's calendar as `yyyy-MM-dd`, the value a date input takes. */
export function todayIso(now = new Date()): string {
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}
